<template>
    <div class="modal fade" id="search" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Поиск по ИНН</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div style="margin: 50px" v-if="isLoading">
                        <span class="spinner"></span>
                    </div>
                    <div v-else>
                        <div class="input-group m-b-5">
                            <input v-model="query" type="text" class="form-control">
                            <div class="input-group-append">
                                <button type="button" class="btn btn-green" @click="search(query)">
                                    Найти
                                </button>
                            </div>
                        </div>
                        <table v-if="data.length" class="table table-condensed table-bordered">
                            <thead>
                            <tr>
                                <th>Поле</th>
                                <th>Значение</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in data" :key="item.key">
                                <td>{{ item.title }}</td>
                                <td>{{ item.value }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-else>
                            Ничего не найдено
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <a href="#" class="btn btn-white" data-dismiss="modal">Отмена</a>
                    <a href="#" class="btn btn-success" data-dismiss="modal" @click="fillForm(data, type)">
                        Заполнить форму
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const TYPES = {
    LEGAL: 'LEGAL',
    INDIVIDUAL: 'INDIVIDUAL'
};

const TYPES_MAP = {
    [TYPES.LEGAL]: 'Компания',
    [TYPES.INDIVIDUAL]: 'Индивидуальный предприниматель',
};

export default {
    created() {
        window.events.$on('suggested', async (query) => {
            if (query) {
                this.search(query);
            }
        })
    },
    data() {
        return {
            type: null,
            isLoading: false,
            data: [],
            query: ''
        }
    },
    methods: {
        async search(query) {
            try {
                this.isLoading = true;
                const response = await Axios.get(`/suggest/credentials?search=${query}`);
                const data = response.data.data;

                this.processSearchResults(data);
            } catch (error) {
                console.error('Error during search:', error);
                this.data = [];
            } finally {
                this.isLoading = false;
            }
        },
        processSearchResults(data) {
            const result = [
                { title: 'ИНН', key: 'inn', value: data.inn },
                { title: 'ОКПО', key: 'credentials[okpo]', value: data.okpo },
                { title: 'ОГРН', key: 'credentials[ogrn]', value: data.ogrn },
                { title: data.type === TYPES.LEGAL ? 'Название организации' : 'ФИО', key: 'name', value: data.type === TYPES.LEGAL ? data.name.short_with_opf : data.name.full },
                { title: 'Адрес', key: 'address', value: data.address.unrestricted_value },
                { title: 'Телефонный номер', key: 'phone', value: data.phones },
                { title: 'Тип', key: 'type', value: TYPES_MAP[data.type] }
            ];

            if (data.type === TYPES.LEGAL) {
                result.push(
                    { title: 'ФИО', key: 'credentials[full_name]', value: data.management.name },
                    { title: 'Должность', key: 'credentials[position]', value: this.firstUpperCase(data.management.post) },
                    { title: 'КПП', key: 'credentials[kpp]', value: data.kpp }
                );
            }

            this.data = result.filter(item => item.value);
            this.type = data.type === TYPES.LEGAL ? 'company' : 'ip';
        },
        firstUpperCase(value) {
            return value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : null;
        },
        fillForm(data, type) {
            if (type) {
                window.events.$emit('setType', type);
                window.events.$emit('fillForm', data);
            }
        }
    }
}
</script>
